module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av348-5454933682090d2ded61651acb53a0e2.jpg";